import React from 'react';
import PropTypes from 'prop-types';

import RIQDropdown from './RIQDropdown.jsx';

import {
    useSetupExport
} from '../hooks/useExport.js';

import {
    useGetExportConfig
} from '../hooks/exportConfigurationHooks.js';


// NOTE this is a port of dashboard/views/exportDropdown.js
const ExportDropdown = function ({instanceId, variant}) {

    const exportConfig = useGetExportConfig(instanceId) || {};
    const {title, timePeriodStr, supportedExportFormats, supportedExportTypes, pptExportConfig, csvExportConfig} = exportConfig;

    const exportOptions = {
        title: title,
        instanceId: instanceId,
        timePeriodStr: timePeriodStr,
        pptExportConfig: pptExportConfig,
        csvExportConfig: csvExportConfig,
        supportedExportFormats: supportedExportFormats
    };

    const setupExportPPT = useSetupExport(instanceId, 'ppt', RivalIQ.enums.exportType.DOWNLOAD, exportOptions);
    const setupExportPDF = useSetupExport(instanceId, 'pdf', RivalIQ.enums.exportType.DOWNLOAD, exportOptions);
    const setupExportPNG = useSetupExport(instanceId, 'png', RivalIQ.enums.exportType.DOWNLOAD, exportOptions);
    const setupExportCSV = useSetupExport(instanceId, 'csv', RivalIQ.enums.exportType.DOWNLOAD, exportOptions);
    const setupExportEmail = useSetupExport(instanceId, null, RivalIQ.enums.exportType.EMAIL, exportOptions);
    const setupExportSchedule = useSetupExport(instanceId, null, RivalIQ.enums.exportType.SCHEDULE, exportOptions);

    let exportDropdownOptions = [];
    if (_.includes(supportedExportTypes, RivalIQ.enums.exportType.DOWNLOAD)) {
        exportDropdownOptions = _(RivalIQ.enums.exportFormatSortOrder)
            .map(format => {
                if (_.includes(supportedExportFormats, format)) {
                    return {
                        id: `dl-${format}`,
                        name: `Download a ${format.toUpperCase()}`
                    };
                }
            })
            .compact()
            .value();
    }

    if (_.includes(supportedExportTypes, RivalIQ.enums.exportType.EMAIL) || _.includes(supportedExportTypes, RivalIQ.enums.exportType.SCHEDULE)) {
        if (exportDropdownOptions.length) {
            exportDropdownOptions.push(RIQDropdown.DIVIDER);
        }

        if (_.includes(supportedExportTypes, RivalIQ.enums.exportType.EMAIL)) {
            exportDropdownOptions.push({
                id: 'email',
                name: 'Email...'
            });
        }

        if (_.includes(supportedExportTypes, RivalIQ.enums.exportType.SCHEDULE)) {
            exportDropdownOptions.push({
                id: 'schedule',
                name: 'Schedule...'
            });
        }
    }

    if (!_.isEmpty(supportedExportTypes) && _.without(supportedExportFormats, RivalIQ.enums.exportFormat.CSV).length) {
        exportDropdownOptions = exportDropdownOptions.concat([
            RIQDropdown.DIVIDER,
            {
                id: 'branding',
                name: 'Customize Branding',
                href: '/settings#themeTab'
            }
        ]);
    }

    function onExportItemSelected(selectedOption) {
        switch (selectedOption.id) {
            case 'dl-ppt':
                return setupExportPPT();
            case 'dl-pdf':
                return setupExportPDF();
            case 'dl-png':
                return setupExportPNG();
            case 'dl-csv':
                return setupExportCSV();

            case 'email':
                return setupExportEmail();

            case 'schedule':
                return setupExportSchedule();

            default:
                throw new Error(`${selectedOption.id} is not implemented yet.`);
        }
    }

    return (
        <div className='tlw-hidden sm_tlw-block'>
            {exportDropdownOptions.length > 0 &&
                <RIQDropdown
                    variant={variant}
                    title='Export'
                    dropdownOptions={exportDropdownOptions}
                    onItemSelected={onExportItemSelected}
                />
            }
        </div>
    );
};

ExportDropdown.propTypes = {
    variant: PropTypes.oneOf(['large', 'small']).isRequired,
    instanceId: PropTypes.string
};

export default ExportDropdown;
